import { createAction, props } from "@ngrx/store";

export const OpenGlobalErrorPopupAction = "[error] Open Global Error Popup";
export const OpenGlobalErrorPopup = createAction(OpenGlobalErrorPopupAction);
export const CloseGlobalErrorPopupAction = "[error] Close Global Error Popup";
export const CloseGlobalErrorPopup = createAction(CloseGlobalErrorPopupAction);
